export const isImg = (extension) => {
    const validateExtensions = ['png', 'gif', 'jpg', 'jpeg'];
    return validateExtensions.includes(extension);
};
